import { Component } from '@angular/core';

@Component({
  selector: 'app-consensus-workshop',
  templateUrl: './consensus-workshop.component.html',
  styleUrls: ['./consensus-workshop.component.css'],
})
export class ConsensusWorkshopComponent {}
